import { render, staticRenderFns } from "./ImageLogo.vue?vue&type=template&id=8e92ba8e&scoped=true"
import script from "./ImageLogo.vue?vue&type=script&lang=ts"
export * from "./ImageLogo.vue?vue&type=script&lang=ts"
import style0 from "./ImageLogo.vue?vue&type=style&index=0&id=8e92ba8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e92ba8e",
  null
  
)

export default component.exports